//@ts-nocheck
import { ChevronRightIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../../stores";
import { STEPS } from "../../stores/utils";
import subjectContents from "../../tutor-revamp/formData/subject.json";
import TutorSubjectsPage from "../../tutor-revamp/Subject";

function buildWrapperProps(store: IRootStore, step: string) {
  let educationData = store.educationWorkHistory.formValues;
  const options = {
    [STEPS.SUBJECT_SELECTION]: {
      store: store.subject,
      supportedCountry: store.supportedCountryData,
      formHeader: "",
      lockedDescription: subjectContents.lockedForm.description,
      displayType: "complex",
      // buttonIsDisabled: !store.subject.completed,
      completed: store.subject.completed,
      canEdit: true,
      shouldDisplayButton:
        store.currentEditableForm === STEPS.SUBJECT_SELECTION &&
        store.subject.completed,
      buttonText: "Save and Continue",
      isCollapsed: true,
      educationAndWorkHistoryData: {
        education: educationData.educations,
        workHistory: educationData.workHistories,
      },
    },
  };
  return {
    ...options[step],
    label: step,
    loading: store.loading,
  };
}
export type SubjectPageType = {
  store: IRootStore;
  onNextStep?: () => void;
  onLogout?: () => any;
  canEditSubject?: boolean;
  loading?: boolean;
  onSubmit: () => any;
  toggleNavigation?: (r: boolean) => void;
  isLiteTutor?: boolean;
  generateDescription: (p: {
    name: string;
    category: string;
    subcategory: string;
  }) => any;
};

const SubjectCreationPage: React.FC<SubjectPageType> = ({
  store,
  onNextStep,
  onLogout,
  canEditSubject = true,
  onSubmit,
  isLiteTutor,
  loading,
  generateDescription,
  toggleNavigation,
}) => {
  function getFormWrapperProps(step: any) {
    let result = buildWrapperProps(store, step);
    return { ...result, onSubmit: () => {} };
  }

  function getPriceSuggestion(subject: any) {
    return store.getPriceSuggestion(subject);
  }

  return (
    <TutorSubjectsPage
      {...getFormWrapperProps(STEPS.SUBJECT_SELECTION)}
      onSubmitSubjects={onSubmit}
      getPriceSuggestion={getPriceSuggestion}
      generateDescription={generateDescription}
      renderPreview={(subjectStore) => {
        return null;
        // return (
        //   <TutorProfile
        //     {...buildProfileInfo(
        //       store,
        //       subjectStore
        //     )} /*onBackClick={onBackClick}*/
        //   />`
        // );
      }}
      // onEditSubject={onEditSubject}
      canEditSubject={canEditSubject}
      isLiteTutor={isLiteTutor}
      toggleNavigation={toggleNavigation}
      proceedToNextStep={
        <Button
          colorScheme={"blue"}
          onClick={onNextStep}
          size="lg"
          isFullWidth
          isLoading={loading}
          loadingText="Submitting application..."
          isDisabled={!store.subject.canProceedToNextPage}
          rightIcon={<ChevronRightIcon fontSize="2xl" />}
        >
          Save and submit
        </Button>
      }
    />
  );
};

export default observer(SubjectCreationPage);
